import useI18nExtended from '~/composables/usei18nExtended'
import {ref, unref} from 'vue'

export const useInputValidation = (options = {}) => {
  const {
    rules = [],
    getAttrs
  } = options

  const i18n = useI18nExtended()

  const errorMessage = ref(null)
  const fallbackValue = ref(null)

  const validate = async (value) => {
    errorMessage.value = null

    // Handle computed refs and plain arrays
    const rulesValue = unref(rules)

    if (!rulesValue || !Array.isArray(rulesValue) || rulesValue.length <= 0) {
      return true
    }

    let isValid = true
    for (let fieldRule of rulesValue) {
      if (!await fieldRule.validator(value)) {
        const translatedMessage = i18n.tv({
          messageKey: fieldRule.message.key,
          messageValues: fieldRule.message.options
        })
        errorMessage.value = errorMessage.value !== null
          ? errorMessage.value + '\n' + translatedMessage
          : translatedMessage
        if (typeof fieldRule.fallbackValue === 'number') {
          fallbackValue.value = fieldRule.fallbackValue
        }
        isValid = false
      }
    }

    return isValid
  }

  const getName = (uuid) => {
    const attrs = getAttrs?.() ?? {}
    return attrs.name || ('enextformelement' + uuid)
  }

  return {
    errorMessage,
    fallbackValue,
    validate,
    getName
  }
}

export default useInputValidation
